
<template>
  <v-menu offset-y v-if="item.done_by_name">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="secondary" icon v-on="on" class="ml-3">
        <v-icon>mdi-information</v-icon> 
      </v-btn>
    </template>
    <v-list dense class="py-1" :outlined="$vuetify.theme.isDark">
      <v-list-item>
        <v-list-item-title>Item Reprovado</v-list-item-title>
      </v-list-item>
      <v-list-item>
        <v-list-item-title>Por: <b>{{ item.done_by_name }}</b></v-list-item-title>
        <v-list-item-action><v-icon> mdi-account </v-icon></v-list-item-action>
      </v-list-item>
      <v-list-item>
        <v-list-item-title>Em: <b>{{$moment(item.created_at).format('lll')}}</b></v-list-item-title>
        <v-list-item-action><v-icon> mdi-calendar </v-icon></v-list-item-action>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
//import validations from '@/mixins/validations'
//import Api from '@/api/index';

export default {
  name: 'ItemReprovedDetailsMenu',
  //mixins: [ validations ],
  props: {
    item: {
      type: Object,
    },
  },
  components: {
    //ComponentName: () => import(''),
  },
  data() {
    return {
      
    }
  },
  methods: {
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
}
</script>

<style scoped>

</style>